import { render, staticRenderFns } from "./SurgeryPatientHistory.vue?vue&type=template&id=1c89a22d&scoped=true"
import script from "./SurgeryPatientHistory.vue?vue&type=script&lang=js"
export * from "./SurgeryPatientHistory.vue?vue&type=script&lang=js"
import style0 from "./SurgeryPatientHistory.vue?vue&type=style&index=0&id=1c89a22d&prod&lang=scss&scoped=true"
import style1 from "./SurgeryPatientHistory.vue?vue&type=style&index=1&id=1c89a22d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c89a22d",
  null
  
)

export default component.exports